import useEffectOnce from './useEffectOnce';
var useUnmount = function (fn) {
    useEffectOnce(function () { return fn; });
};
export default useUnmount;
